import Icona from 'components/3catinfo/ui/Icona';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './tempsLectura.module.scss';

const TempsLectura = (props) => {
    const { showIcon, estil, inline, text, className } = props;

    const stylesTempsLectura = clsx({
        [styles.tempsLectura]: true,
        [styles.inline]: inline,
        [styles[estil]]: !__isEmpty(estil),
        [className]: !!className
    });

    return (
        <div className={stylesTempsLectura} data-testid='item-noti-tempslectura'>
            {showIcon && (
                <Icona
                    className={styles.icona}
                    mida={20}
                    icona='rellotge'
                    isBlanc={false}
                    alt='Temps de lectura'
                    ariaHidden={true}
                />
            )}
            <span>{`${text} min`}</span>
        </div>
    );
};

TempsLectura.defaultProps = {
    showIcon: true,
    inline: true
};

export default TempsLectura;
